import { Injectable } from '@angular/core';
import { compress, compressToUint8Array, decompress, decompressFromUint8Array } from 'lz-string';

@Injectable({
    providedIn: 'root',
})
export class LZStringService {
    public compress(data: string): string {
        return compress(data);
    }

    public compressToUint8Array(data: string): Uint8Array {
        return compressToUint8Array(data);
    }

    public decompress(compressed: string): string {
        const decompressed = decompress(compressed);

        if (decompressed === null) {
            throw new Error(`LZStringService: decompress: Unable to decompress data!`);
        }
        return decompressed;
    }

    public decompressFromUint8Array(data: Uint8Array): string {
        const decompressed = decompressFromUint8Array(data);

        if (decompressed === null) {
            throw new Error(`LZStringService: decompressFromUint8Array: Unable to decompress data!`);
        }
        return decompressed;
    }
}
